import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { pushIf } from "./utils/pushIf";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceZoneRetrievalNotificationState = createStateReducer(initialState, {
  [events.retrieveZoneFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "retrieveZone",
        flags: pushIf({
          zoneNotFound: error.wasZoneNotFound,
          unExpectedError: error.hasUnexpectedError,
        }),
        args: { failure: "true", message: error.message },
      },
      state.queue,
    ),
  }),
});

export { reduceZoneRetrievalNotificationState };
